import React, { useReducer } from 'react'
import AuctionContext from './auctionContext'
import AuctionReducer from './auctionReducer'
import { apiCall } from '@/product//common/api'
import { response } from '@/product//context/common'
import {
    GET_ALL_SEARCH,
    GET_ALL_PAST_SEARCH,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_DASHBOARD,
    GET_EMD_LIST,
    GET_MASTER_DETAILS,
} from './auctionTypes'

const AuctionState = (props) => {
    const initialState = {
        search_allauctions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        search_all_pastauction: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        auction_emd_list: {
            records: [],

            from: '',
        },
        search_alldashboardauctions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        bank_details: {
            records: [],
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(AuctionReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllAuctionProducts = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'search', formData, '', 'front/auction', true),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                if (fromVariable === 'pastauction') {
                    dispatch({
                        type: GET_ALL_PAST_SEARCH,
                        payload: {
                            records: res.data.data.responseData.records.length
                                ? res.data.data.responseData.records
                                : [],
                            totalRecords: res.data.data.responseData.totalRecords,
                            setDisp: res.data.data.responseData.setDisp,
                            from: fromVariable,
                        },
                    })
                } else {
                    dispatch({
                        type: GET_ALL_SEARCH,
                        payload: {
                            records: res.data.data.responseData.records.length
                                ? res.data.data.responseData.records
                                : [],
                            totalRecords: res.data.data.responseData.totalRecords,
                            setDisp: res.data.data.responseData.setDisp,
                            from: fromVariable,
                        },
                    })
                }
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addWatchlistauction = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'addAuctionWatchList', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, 'auctionwatchlist')
        } catch (err) {
            resp.commonErrorResponse('auctionwatchlist')
        }
    }

    const auctionAccessRequest = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'auctionAccessRequest', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, fromVariable || 'auctionAccessRequest')
        } catch (err) {
            resp.commonErrorResponse(fromVariable || 'auctionAccessRequest')
        }
    }

    const removeWatchlistauction = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'removeAuctionWatchList', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, 'auctionwatchlist')
        } catch (err) {
            resp.commonErrorResponse('auctionwatchlist')
        }
    }
    const getAllDashboardwatchlist = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'auctionWatchList', formData, '', 'auction'),
            ])
            let fromValue = from || 'displaywatchlist'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_DASHBOARD,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                        from: fromValue,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateAuctionTerms = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'updateAuctionTerms'
            const [res] = await Promise.all([
                apiCall('post', 'updateAuctionTerms', formData, '', 'auction'),
            ])
            console.log(res, 'reff')

            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllDashboardAuctions = async (formData, from) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'myBids', formData, '', 'auction')])
            const fromValue = from || 'dashboard'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_DASHBOARD,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                        from: fromValue,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getEmdListForAuction = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getemdlist', formData, '', 'custom/front/auction', false, true),
            ])
            const from = fromVariable ? fromVariable : 'Auctions'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_EMD_LIST,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],

                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllBankDetails = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getMasterBankDetails', formData, '', '', false, true),
            ])
            const from = fromVariable ? fromVariable : 'Auctions'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_MASTER_DETAILS,
                    payload: {
                        records: res.data.data.responseData.records,

                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const cashFreeEmdPayment = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'generate_link', formData, '', 'paymentThird/cashfree'),
            ])
            resp.commonResponse(res.data, 'generate_link_cashfree')
        } catch (err) {
            resp.commonErrorResponse('generate_link_cashfree')
        }
    }

    const cashFreeResponseCheck = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'response_check', formData, '', 'paymentThird/cashfree'),
            ])
            resp.commonResponse(res.data, 'cashfreeResponse')
        } catch (err) {
            resp.commonErrorResponse('cashfreeResponse')
        }
    }
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AuctionContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                search_allauctions: state.search_allauctions,
                search_all_pastauction: state.search_all_pastauction,
                responseStatus: state.responseStatus,
                search_alldashboardauctions: state.search_alldashboardauctions,
                bank_details: state.bank_details,
                clearResponse,
                getAllAuctionProducts,
                getAllDashboardAuctions,
                auctionAccessRequest,
                updateAuctionTerms,
                addWatchlistauction,
                getAllDashboardwatchlist,
                cashFreeResponseCheck,
                cashFreeEmdPayment,
                removeWatchlistauction,
                auction_emd_list: state.auction_emd_list,
                getEmdListForAuction,
                getAllBankDetails,
            }}
        >
            {props.children}
        </AuctionContext.Provider>
    )
}

export default AuctionState
